import { useI18n } from '../../shared/i18n/I18nProvider';
import { Navigate, Outlet } from 'react-router';
import { useSession } from '../../modules/auth';
export function RequireSession() {
  const { t } = useI18n();

  const { auth, status, transitioning, bootstrapError, bootstrap } = useSession();
  if (status === 'loading' || transitioning) return <main className="access-denied" role="status">{t("Đang khôi phục không gian cửa hàng…")}</main>;
  if (status === 'error') return <main className="access-denied"><p role="alert">{bootstrapError}</p><button className="btn btn-primary" onClick={() => { void bootstrap(); }}>{t("Thử lại")}</button></main>;
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
}
